export default __webpack_public_path__ + "static/media/qbIcon.25205df4.svg";